module.exports = __webpack_public_path__ + "img/mineBg.19984300.png";